import { Typography } from '@material-ui/core';
import BlockBox from "components/generics/BlockBox";
import clsx from 'clsx';
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
    container: {
        position: 'relative',
        '& a': {
            textDecoration: 'none',
        }
    },
    section: {
    },
    wrapper: {
        padding: "20px 0",
    },
    wrapperItem: {
        padding: "0 50px",
        '& img': {
            width: '300px'
        }
    },
    '@media screen and (max-width: 760px)': {
        wrapper: {
            padding: "20px 0",
        },
        wrapperItem: {
            padding: "0 30px",
            '& img': {
                width: '150px',
                height: 'auto',
            }
        }

    }
})

function ForQueryBox() {
    const classes = useStyles();
    return (
        <BlockBox>
            <div className={classes.container}>
                <div className="max-width">
                    <div className={classes.wrapper}>
                        <div
                            className={"flex-center flex-column-sm"}
                        >
                            <div className={classes.wrapperItem}>
                                <img
                                    src={'https://res.cloudinary.com/dttau3gcw/image/upload/v1621238192/Group_107_zwk8au.png'}
                                    alt="query"
                                />
                            </div>
                            <div className={clsx(classes.wrapperItem, "center")}>
                                <Typography
                                    variant="h4"
                                >
                                    For queries reach out to
                                </Typography>
                                <a
                                    href="mailto:pr@stayqrious.com"
                                >
                                    <Typography
                                        variant="h4"
                                        color="primary"
                                    >
                                        pr@stayqrious.com
                                </Typography>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </BlockBox>
    )
}

export default ForQueryBox;